import bg from "svg/footer.svg";
import "./footer.scss";

export default function Footer() {
	return (
		<footer className="footer" style={{ backgroundImage: `url(${ bg })`}}/>
	)
}